const FALLBACK_TZ = 'UTC';

export function formatTimezoneLabel(tz: string): string {
  try {
    const offset =
      new Intl.DateTimeFormat('en', { timeZone: tz, timeZoneName: 'longOffset' })
        .formatToParts(new Date())
        .find((p) => p.type === 'timeZoneName')?.value ?? 'GMT';
    return `(${offset.replace('GMT', 'UTC')}) ${tz}`;
  } catch {
    return tz;
  }
}

function resolveTimezone(timeZoneId?: string): string {
  if (!timeZoneId) return FALLBACK_TZ;
  try {
    Intl.DateTimeFormat(undefined, { timeZone: timeZoneId });
    return timeZoneId;
  } catch {
    return FALLBACK_TZ;
  }
}

export function formatFarmDate(dateStr: string, timeZoneId?: string, locale?: string): string {
  const tz = resolveTimezone(timeZoneId);
  return new Intl.DateTimeFormat(locale || 'en-NL', {
    timeZone: tz,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(new Date(dateStr));
}

export function formatFarmTime(dateStr: string, timeZoneId?: string, locale?: string): string {
  return new Intl.DateTimeFormat(locale || 'en-NL', {
    timeZone: resolveTimezone(timeZoneId),
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }).format(new Date(dateStr));
}
